import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useIntl } from "react-intl";
import { Col } from 'reactstrap';
import { EditScheduleDTO } from '../models/Scheduler/EditScheduleDTO';
import EditSchedulerFirstTab from './Scheduler/EditSchedulerFirstTab';
import EditSchedulerSecondTab from './Scheduler/EditSchedulerSecondTab';
import { ScheduleDetailsDTO } from '../models/Scheduler/ScheduleDetailsDTO';

export type EditScheduleComponentProps = {
    childrenColumnSize?: number;
    scheduleId: number | null;
    currentSchedule: ScheduleDetailsDTO | null;

    onClose: () => void;
}

// Edit Schedule Tabs
export function EditScheduleComponent({ childrenColumnSize = 12, ...props }: EditScheduleComponentProps) {

    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);

    const [scheduleDTO, setScheduleDTO] = useState<EditScheduleDTO>({
        scheduleId: props.scheduleId,

        assistanceId: props?.currentSchedule?.assistanceId ?? null,
        assistanceName: props?.currentSchedule?.assistanceDocument ?? null,

        clientErpId: props?.currentSchedule?.clientErpId ?? null,
        clientName: props?.currentSchedule?.clientName ?? null,

        equipmentErpId: props?.currentSchedule?.equipmentErpId ?? null,
        equipmentCarPlate: props?.currentSchedule?.equipmentCarPlate ?? null,
        equipmentSerialNumber: props?.currentSchedule?.equipmentSerialNumber ?? null,
        equipmentBrand: props?.currentSchedule?.equipmentBrand ?? null,
        equipmentModel: props?.currentSchedule?.equipmentModel ?? null,
        equipmentSku: props?.currentSchedule?.equipmentSku ?? null,

        startDate: props?.currentSchedule?.startDate ?? null,
        endDate: props?.currentSchedule?.endDate ?? null,

        notes: props?.currentSchedule?.notes ?? null,
        observations: props?.currentSchedule?.observations ?? null,
        technicianCode: props?.currentSchedule?.technicianCode ?? null,

        type: props?.currentSchedule?.type ?? null,
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };


    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.EditScheduler.Tabs.FirstTab" })} {...a11yProps(0)} />
                    <Tab label={`${scheduleDTO.type}`} {...a11yProps(1)} />
                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                <EditSchedulerFirstTab
                    scheduleDTO={scheduleDTO}
                    setScheduleDTO={setScheduleDTO}
                    onClose={props.onClose}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={1} childrenColumnSize={childrenColumnSize}>
                <EditSchedulerSecondTab
                    scheduleDTO={scheduleDTO}
                    setScheduleDTO={setScheduleDTO}
                    onClose={props.onClose}
                />
            </TabPanel>
        </>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}